import {React, useEffect} from 'react';
import ReactDOM from 'react-dom';
import { StyleContext,  useStyle } from '../../context/styleContext/styleContext';
import Button from '@mui/material/Button';
import ReactGA from 'react-ga4';

const TermsModal = ({ isOpen, close, children }) => {

  const { style, setStyle } = useStyle();
  ReactGA.send({
    hitType:"pageview",
    page:"terms_modal",
    title:"terms_modal",
  })
  useEffect(() => {
    document.title = 'Brainwave Sound Lab | Cutting-Edge Audio Processing | Terms and Conditions';
}, []);
  
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div style={modalStyle}>
      <div style={{borderColor:style.color3, borderStyle:'solid', borderWidth:'2px', padding:'5px'}}>
      <div style={modalContentStyle}>
        {children}
      </div>
      <Button size='small' onClick={close} sx={{ my: 2, width:'100%', color: style.color4, backgroundColor: style.color2, display: 'block', margin:'auto', fontSize:'16pt', borderWidth:'2px', borderRadius:'0px', borderColor:style.color1, borderStyle:'solid', '&:hover': {backgroundColor: style.color3, color: style.color2 }}}>
               <strong>OK</strong>
            </Button>

      </div>

    </div>,
    document.getElementById('modal-root')
  );
};

const modalStyle = {

  
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.85)',
  display: 'flex',
  flexDirection:'column',
  alignItems: 'center',
  justifyContent: 'center',
  maxHeight: '100vh',
  marginTop:'0px',
  overflowY: 'auto',
  zIndex: "1000",
};

const modalContentStyle = {
  padding: '20px',
  background: 'rgb(39, 55, 77)',
  borderRadius: '0px',
  borderColor: 'rgb(39, 55, 77)',
  borderWidth:'2px',
  borderStyle:'solid',
  maxWidth: '500px',
  minHeight: '300px',
  maxHeight: '350px',
  overflowY:'auto',
  margin: 'auto',
  marginTop:'0px',
  display: 'flex',
  flexDirection: 'column',
  color:'rgb(221, 230, 237)'
};

const buttonStyle = {
  marginTop: '20px',
  alignSelf: 'center'
};

export default TermsModal;
